import { render, staticRenderFns } from "./SectorViewModal.vue?vue&type=template&id=201faa76&"
import script from "./SectorViewModal.vue?vue&type=script&lang=js&"
export * from "./SectorViewModal.vue?vue&type=script&lang=js&"
import style0 from "@/styles/SectorViewModal.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports